module.exports = __webpack_public_path__ + "media/majom_m.82209fa7.mp3";